import React, { useEffect, useState } from 'react'
import { MainBackgroundPage } from '../main-background-page'
import { SelectSystemModel } from './select-system-model'
import { ConfirmModal } from '../common/confirm-modal'
import { useTranslation } from 'react-i18next'
import { useLogout } from '@/hooks/use-logout'
import { agentsHooks } from '@/manager'

export const SelectSystemPage = () => {
  const { t } = useTranslation();
  const { handleLogout } = useLogout();
  const {
    agents,
    loading,
    hasAvailableAgent,
    isCustomDomain,
    customDomainDisabledDescription
  } = agentsHooks.useAgentData();

  const [openSelectModal, setSelectModal] = useState(isCustomDomain ? false : true);
  const [openTipModal, setOpenTipModal] = useState(false);
  const [openDisabledModal, setOpenDisabledModal] = useState(false);
  const [disabledDescription, setDisabledDescription] = useState('');

  useEffect(() => {
    if (loading) return;

    // 定制域名：只判断是否展示停用弹窗，不走通用的 hasAvailableAgent 逻辑
    if (isCustomDomain) {
      setSelectModal(false);
      setOpenTipModal(false);
      if (customDomainDisabledDescription) {
        setDisabledDescription(customDomainDisabledDescription);
        setOpenDisabledModal(true);
      } else {
        setOpenDisabledModal(false);
        setDisabledDescription('');
      }
      return;
    }

    if (!hasAvailableAgent) {
      setSelectModal(false);
      setOpenTipModal(true);
    } else {
      setSelectModal(true);
      setOpenTipModal(false);
    }
  }, [hasAvailableAgent, loading, isCustomDomain, customDomainDisabledDescription]);

  const handleContact = () => {
    window.location.href = 'mailto:support@bizdesk.ai'
  }

  return (
    <>
      <MainBackgroundPage />
      {/* 选择智能体弹窗 */}
      {openSelectModal && (
        <SelectSystemModel open={openSelectModal} agents={agents} />
      )}
      {/* "暂无可用智能体，请联系管理员开通" 弹窗 */}
      {openTipModal && (
        <ConfirmModal
          open={openTipModal}
          onOpenChange={setOpenTipModal}
          title={t('select_system.agent_empty.title')}
          description={t('select_system.agent_empty.desc')}
          cancel={t('select_system.agent_empty.logout')}
          confirm={t('select_system.agent_empty.contact')}
          neverClose
          overlayClassName='bg-[rgba(0,0,0,0.2)] backdrop-filter backdrop-blur'
          onCancel={handleLogout}
          onConfirm={handleContact}
        />
      )}
      {/* 定制域名下，"智能体/账号已被停用，请联系相关管理员处理" 弹窗 */}
      {openDisabledModal && (
        <ConfirmModal
          open={openDisabledModal}
          onOpenChange={setOpenDisabledModal}
          title={t('select_system.custom_domain_disabled.title')}
          description={disabledDescription}
          cancel={t('select_system.agent_empty.logout')}
          confirm={t('select_system.agent_empty.contact')}
          neverClose
          overlayClassName='bg-[rgba(0,0,0,0.2)] backdrop-filter backdrop-blur'
          onCancel={handleLogout}
          onConfirm={handleContact}
        />
      )}
    </>
  )
}
